import { Navigate } from "react-router-dom";

const Landing = () => {
  const sticky = localStorage.getItem('last-group');
  if (sticky) return <Navigate to = {`/groups/details/${sticky}`}  replace = {true}/>;
  else return <Navigate to = {`/dashboard`}  replace = {true}/>;
}

export default Landing;
